<iframe [src]="url | safe" style="width: 100%; height: 100%; min-height: 1000px;" frameBorder="0">Browser not compatible.</iframe>